import React from 'react'

const DEFAULT_WIDTH = 24
const DEFAULT_HEIGHT = 24

const SignalIcon = ({ width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT }: { width?: number; height?: number }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3 12.0006C3 8.84126 4.48882 6.05432 6.76224 4.35078L5.86276 3.15039C3.21546 5.13409 1.5 8.36375 1.5 12.0006C1.5 15.6374 3.21546 18.8671 5.86276 20.8508L6.76224 19.6504C4.48882 17.9468 3 15.1599 3 12.0006Z'
        fill='#434343'
      />
      <path
        d='M17.2378 4.35078C19.5112 6.05432 21 8.84126 21 12.0006C21 15.1599 19.5112 17.9468 17.2378 19.6504L18.1372 20.8508C20.7845 18.8671 22.5 15.6374 22.5 12.0006C22.5 8.36375 20.7845 5.13409 18.1372 3.15039L17.2378 4.35078Z'
        fill='#434343'
      />
      <path
        d='M8.70762 8.0948C7.5068 9.0196 6.75 10.4295 6.75 12.0006C6.75 13.5717 7.5068 14.9816 8.70762 15.9064L7.79238 17.0948C6.24982 15.9068 5.25 14.0702 5.25 12.0006C5.25 9.93103 6.24982 8.09437 7.79238 6.90639L8.70762 8.0948Z'
        fill='#434343'
      />
      <path
        d='M17.25 12.0006C17.25 10.4295 16.4932 9.0196 15.2924 8.0948L16.2076 6.90639C17.7502 8.09437 18.75 9.93103 18.75 12.0006C18.75 14.0702 17.7502 15.9068 16.2076 17.0948L15.2924 15.9064C16.4932 14.9816 17.25 13.5717 17.25 12.0006Z'
        fill='#434343'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 12.0006C9 10.3437 10.3431 9.00059 12 9.00059C13.6569 9.00059 15 10.3437 15 12.0006C15 13.6574 13.6569 15.0006 12 15.0006C10.3431 15.0006 9 13.6574 9 12.0006ZM12 10.5006C11.1716 10.5006 10.5 11.1722 10.5 12.0006C10.5 12.829 11.1716 13.5006 12 13.5006C12.8284 13.5006 13.5 12.829 13.5 12.0006C13.5 11.1722 12.8284 10.5006 12 10.5006Z'
        fill='#434343'
      />
    </svg>
  )
}

export default SignalIcon
